export default __webpack_public_path__ + "static/media/ClodCrusher.359318dc.jpg";